import {
  Box,
  Button,
  Center,
  Image
} from "@chakra-ui/react"
import {Link as RouterLink} from 'react-router-dom'
import featureRiderImgLG from './featured-rider-image_lg.webp'
import featureRiderImgMd from './featured-rider-image_md.webp'

export default function FeaturedBook({priority = 'high'}: {priority: 'high' | 'low' | 'auto'}) {
  return (
    <Box position={'relative'} boxShadow={'lg'} borderRadius={12} >
      <Image 
        loading={priority === 'high' ? "eager" : "lazy"}
        fetchPriority={priority}
        objectPosition={'50% 40%'}
        borderRadius={12}
        objectFit={'cover'}
        src={featureRiderImgLG}
        srcSet={`${featureRiderImgMd} 768w, ${featureRiderImgLG} 992w`}
        alt="Kolarz - okładka książki"
        minHeight={'550px'}
        width={1220}
        height={{ base: '65vh', md: '70vh', lg: '75vh' }}
        top={0}
      />
      <Box
        as='div'
        width={'100%'}
        bgColor={'rgba(255, 255, 255, 0.6)'}
        height={20}
        position={'absolute'} 
        bottom={'0'}
        zIndex={10} 
        borderBottomRadius={12}
        pt={4} px={2}>

        <Center maxWidth={'sm'} m={'auto'} >
          <Button as={RouterLink} borderColor={'black'} bgColor={'white'} color={'black'} borderWidth={2} size={'lg'} to={'/ksiazka/krabbe-kolarz-papier'}>Zobacz szczegóły 📖</Button>
        </Center>
      </Box>
    </Box>
  )
}